import { Component, effect, inject, input, output } from '@angular/core';
import { DownloadUtilService, InterestRateCalculationService, SimpleMessageService, TrackingIdService } from '@shared/data';
import { ErrorDto, GeschaeftsstatusService, Handelsgeschaeft, TradeEvent, TradeEventType } from 'lion-api';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-trade-event-dialog',
  standalone: false,
  templateUrl: './trade-event-dialog.component.html',
  styleUrl: './trade-event-dialog.component.scss'
})
export class TradeEventDialogComponent {
  geschaeft = input.required<Handelsgeschaeft>();
  tradeEventDialogVisible = input(false);
  tradeEventDialogVisibleChange = output<boolean>();
  tradeIdWithoutVersion = '';
  private readonly MESSAGE_KEY = 'trade-event';
  private readonly simpleMessageService = inject(SimpleMessageService);
  protected readonly messageState = this.simpleMessageService.getMessageState(this.MESSAGE_KEY);
  protected interestCalculationService = inject(InterestRateCalculationService);
  protected geschaeftsstatusService = inject(GeschaeftsstatusService);
  protected translateService = inject(TranslateService);
  protected downloadUtilService = inject(DownloadUtilService);
  protected trackingService = inject(TrackingIdService);
  protected datePipe = inject(DatePipe);
  protected currentDate = new Date();

  constructor() {
    effect(() => {
      this.simpleMessageService.clearInlineMessage(this.MESSAGE_KEY);
      const geschaeft = this.geschaeft();
      if (geschaeft?.murexId) {
        if (geschaeft.murexId.includes('-')) {
          this.tradeIdWithoutVersion = geschaeft.murexId.substring(0, geschaeft.murexId.indexOf('-'));
        } else {
          this.tradeIdWithoutVersion = geschaeft.murexId;
        }
      }

      if (geschaeft?.tradeEvents) {
        geschaeft.tradeEvents = geschaeft.tradeEvents.map((item) => {
          const tradeIdVersionAsInt = item.id ? this.getTradeIdVersionAsInt(item.id) : 0;
          const newBalance = this.getBalanceNew(item);
          const effectiveZins = this.interestCalculationService.getEffectiveZinssatzHg(item?.interestRate, geschaeft?.typ);

          return {
            ...item,
            tradeIdVersionAsInt: tradeIdVersionAsInt,
            newBalance: newBalance,
            effectiveZins: effectiveZins
          };
        });
        geschaeft.tradeEvents.sort((a, b) => {
          if (a?.id && b?.id) {
            return this.getTradeIdVersionAsInt(a.id) - this.getTradeIdVersionAsInt(b.id);
          } else {
            return 0;
          }
        });
      }
      console.log('TRADE_EVENTS', geschaeft?.tradeEvents);
    });
  }

  onDialogHide() {
    this.simpleMessageService.clearInlineMessage(this.MESSAGE_KEY);
    this.tradeEventDialogVisibleChange.emit(false);
  }

  getBalanceNew(item: TradeEvent) {
    let newBalance = 0;
    if (item.type === TradeEventType.BetragReduktion) {
      newBalance = (item.balance ?? 0) - (item.amount ?? 0);
    } else {
      newBalance = (item.balance ?? 0) + (item.amount ?? 0);
    }
    return newBalance;
  }

  getTradeIdVersionAsInt(tradeId: string) {
    let tradeVersion = 1;
    if (tradeId && tradeId.includes('-')) {
      tradeVersion = Number(tradeId.substring(tradeId.indexOf('-') + 1));
    }
    return tradeVersion;
  }

  exportTradeEventsInCSV() {
    const currentDate = this.datePipe.transform(new Date(), 'yyyyMMdd');
    const murexId = this.geschaeft().murexId ?? '0';
    const fileName = 'TradeEvents_' + murexId + '_' + currentDate + '.csv';

    this.geschaeftsstatusService.geschaeftsstatusTradeEventCsvExportPost(this.trackingService.generateTrackingId(), this.geschaeft()).subscribe({
      next: (next: string) => {
        this.downloadUtilService.downloadCsvFile(next, fileName);
      },
      error: () => {
        this.simpleMessageService.sendInlineErrorMessage(this.MESSAGE_KEY, this.translateService.instant('businessStatus.error.detail.csvError'));
      }
    });
  }

  printTradeEventsInPDF() {
    //TODO: Was im Falle wenn keine murexId?

    this.geschaeftsstatusService.geschaeftsstatusTradeEventPdfExportPost(this.trackingService.generateTrackingId(), this.geschaeft()).subscribe({
      next: (response) => {
        const murexId = this.geschaeft().murexId ?? 'ohneGeschaeftsnummer';
        const blob = new Blob([response], { type: 'application/pdf' });
        const filename = `Tradeevents_${murexId}`;
        saveAs(blob, `${filename}.pdf`);
      },
      error: (err: ErrorDto) => {
        console.error(`Error while downloading pdf document: ${err?.message}`);
        this.simpleMessageService.sendInlineErrorMessage(this.MESSAGE_KEY, this.translateService.instant('businessStatus.details.printError'));
      }
    });
  }
}
